// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4129 ? "7bf36345" : chunkId) + "." + {"1919":"da2166749b5d5e6e","2741":"5a19e689cbd03c41","4129":"94adc6240e4054d8","6047":"698c7b011edcdd10","6693":"11b8d2644b5a7313","6885":"b35a1c6c6f3e4ff9","7733":"a80ee904c028ec60","8428":"f43ba2e990acb216"}[chunkId] + ".js";
};